<template>
  <div class="wrap">
    <div class="topBg"></div>
    <div class="wrapContent">
      <!-- 会员基本信息 -->
      <div class="name">
        <p class="p1">
          {{greetingsTime}}，{{user.username }}
        </p>
        <p class="p2">
          <span>{{signTel}}</span>
          <span class="icon"><i class="iconfont icon-phone"></i></span>
          <span>{{pc_lang['Last_login']}}：2019-09-18 18:24:36</span>
        </p>
      </div>
      <!-- 余额充值、账户绑定 -->
      <div class="recharge wrapBox">
        <div class="child one">
          <div class="left">
            <h5>
              {{pc_lang.Credit_balance2}}
            </h5>
            <p>
              {{pc_lang.Asia5b_pays_support_with_QR_code_scan_more_convenient_Support_RMB_Malaysian_Ringgit_and_other_currencies}}
            </p>
            <div>
              <el-button type="primary" size="mini" @click="()=> $router.push({ name: 'Recharge' })">{{pc_lang.Top_up_now}}</el-button>
            </div>
          </div>
          <img src="/image/aap_02.jpg" alt="" class="right">
        </div>
        <!-- 绑定支付 -->
        <div class="child two">
          <h5>
            {{pc_lang.Bind_payment_method}}
            <span>{{pc_lang.Bind_payment_method2}}：<abbr>4个</abbr></span>
          </h5>
          <p>
            <router-link tag="i" to="/user/bind" class="iconfont icon-icon-test1"></router-link>
          </p>
          <div>{{pc_lang.Add_method}}</div>
        </div>
        <!-- 导航 -->
        <div class="child three">
          <h5>
            {{pc_lang.Account_navigation}}
          </h5>
          <div>
            <p v-for="item in menuList" :key="item.href" @click="$router.push({ name: item.href })">
              <i class="iconfont" :class="item.icon"></i>
              {{ item.title }}
            </p>
          </div>
        </div>
      </div>
      <!-- 余额显示 -->
      <div class="balance wrapBox">
        <div class="child" v-for="item in balanceList.slice(0,showBalanceNumber)" :key="item.currency_short">
          <h5>
            {{item.currency_short}} {{pc_lang.Balance}}
          </h5>
          <p>
            {{item.amount}}
<!--            <sup>{{pc_lang.yuan}}</sup>-->
          </p>
          <div>
            <el-button type="primary" size="mini" @click="()=> $router.push({ path: '/recharge?currency=' + item.currency_short })">{{pc_lang.Top_up}}</el-button>
            <router-link tag="span" :to="'/withdrawals?currency=' + item.currency_short">{{pc_lang.Withdraw}}</router-link>
            <router-link tag="span" :to="{name: 'Transfer', query: {currency_short: item.currency_short}}">{{pc_lang.Fund_Transfer}}</router-link>
            <router-link tag="span" :to="{name: 'Transactions', params: {currency_short: item.currency_short}}">{{pc_lang.Inquiry}}</router-link>
          </div>
        </div>
        <div class="show_more" @click="showBalanceNumber = showBalanceNumber > 3 ? 3 : 100" v-html="pc_lang.More_currencies_selection"></div>
      </div>
      <!-- 最近消费记录 -->
      <div class="history wrapBox">
        <h5>
          <p>{{pc_lang.Recent_transaction_records}}</p>
          <div>
            <router-link tag="span" to="/transactions">{{pc_lang.Transaction_records}}</router-link>
            <router-link tag="span" to="/balanceRecord">{{pc_lang.Balance_record}}</router-link>
          </div>
        </h5>
      </div>
      <TransactionsForm :formList="tableData" class="formItems" @handleCheck="handleCheck"></TransactionsForm>

    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Vue from 'vue'
  import {Button} from 'element-ui'
  import TransactionsForm from '@/components/ui/TransactionsForm'
  import {mapGetters} from 'vuex'
  import both from '@/utils/storage'

  import * as API_PAY from '@/api/pay'
  import * as INDEX_API from '@/api/index'

  Vue.use(Button)

  export default {
  name: 'Riches',
  components:{
    TransactionsForm,
  },
  computed: {
    ...mapGetters(['user']),
    /* 问候时间 */
    greetingsTime() {
      return new Date().getHours() > 12 ? this.pc_lang.Evening : this.pc_lang.Morning
    },
    /* 手机加密 */
    signTel() {
      let tel = this.user.mobile
      return !!!tel ? '' : tel.replace(/^(\d{3})\d*(\d{3})$/,'$1****$2')
    },
    menuList() {
      return [
        {
          icon: 'icon-jibenxinxi',
          title: this.pc_lang.Basic_Information,
          href: 'UserInfo'
        },
        {
          icon: 'icon-anquanshezhi',
          title: this.pc_lang.Security_Settings,
          href: 'UserSafety'
        },
        {
          icon: 'icon-duoguojiafuwu',
          title: this.pc_lang.Balance_record,
          href: 'BalanceRecord'
        },
        {
          icon: 'icon-xiaoxitixing',
          title: this.pc_lang.message_notification,
          href: 'UserMsg'
        }
      ]
    }
  },
  data() {
    return {
      tableData: [],
      /* 筛选form */
      conditionsForm: {
        tradeType: '',
        currencyShort: '',
        tradeStatus: '',
        time: '',
        start_time: '',
        end_time: '',
        start_money: '',
        end_money: '',
        keyword: '',
        page_size: 10,
        page_number: 1,
      },
      /* 余额列表 */
      balanceList: [],
      /* 余额列表显示条数 */
      showBalanceNumber: 3,
      /* 默认 */
      defaultBalanceList: [
        /*{
          "currency_short": "MYR",
          "amount": 0.00,
        },
        {
          "currency_short": "RMB",
          "amount": 0.00,
        },
        {
          "currency_short": "THB",
          "amount": 0.00,
        },
        {
          "currency_short": "IDR",
          "amount": 0.00,
        },
        {
          "currency_short": "VND",
          "amount": 0.00,
        },
        {
          "currency_short": "PHP",
          "amount": 0.00,
        }*/
      ]
    }
  },
  async mounted() {

  },
  created() {

    INDEX_API.getCurrency().then((res)=>{

      this.defaultBalanceList = res.data.map(obj => {
        return {
          "currency_short": obj.currency_short,
          "amount": 0.00,
        }
      })

      /* 初始化余额 */
      this.getUserBalance().then(res=> {
        res.forEach(obj=> {
          for (var i = this.defaultBalanceList.length - 1; i >= 0; i--) {
            if (obj.currency_short == this.defaultBalanceList[i].currency_short) {
              this.defaultBalanceList.splice(i,1)
            }
          }
        })
        this.balanceList = this.balanceList.concat(this.defaultBalanceList)
      })
    })


    /* 获取交易记录 */
    this.getDealItems()
  },
  methods: {
    /* 查看详情 */
    handleCheck(item) {
      // this.$router.push({path: '/tradeDetails?trade_id=' + item.trade_id})
    },
    /* 获取用户余额 */
    getUserBalance() {
      return new Promise((resolve, reject)=> {
        API_PAY.getUserBalance().then(res=>{
          this.balanceList = res.data

          resolve(res.data)
        },
        rej=>{
          console.log('rej', rej)
          reject(rej)
        })
      })
    },
    /* 获取交易记录 */
    getDealItems() {
      let params = JSON.parse(JSON.stringify(this.conditionsForm))
      API_PAY.dealTransactions(params).then(res=> {
        let data = res.data.data
        data.forEach(obj=> {
          try{
            /* 转换时间 */
            obj.creation_time = both.getChinaTime(obj.creation_time * 1000)

          }catch(err){
            console.log(err)
          }
        })
        this.tableData = data
      },rej=> console.log(rej))
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  position: relative;
}

.topBg{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 260px;
  z-index: 1;
  background: url('/image/bg2.jpg') no-repeat center;
  background-size: cover;
}

.wrapContent{
  position: relative;
  z-index: 2;
  .name{
    padding: 32px 0 40px;
    color: #fff;
    .p1{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 15px;
    }
    .p2{
      .icon{
        border: 1px solid #fff;
        border-radius: 50%;
        padding: 3px;
        margin: 0 10px;
        display: inline-block;
        transform: scale(.9);
        i{
          font-size: 16px;
        }
      }
    }
  }
  .wrapBox{
    flex-wrap: wrap;
    @extend .border;
    border-bottom: 0;
    background: #fff;
    .child{
      flex: 1;
      padding: 16px 20px;
      border-right: $border;
      border-bottom: $border;
      height: 158px;
      min-width: 370px;
      &:nth-child(3n){
        border-right: 0;
      }
      h5{
        font-size: 18px;
        margin-bottom: 10px;
        span{
          font-size: 14px;
          color: #777;
          font-weight: 500;
          margin-left: 6px;
          abbr{
            color: $blue;
          }
        }
      }
    }
  }
  // 充值
  .recharge{
    display: flex;
    .one{
      display: flex;
      align-items: center;
      position: relative;
      img{
        width: 96px;
      }
      .left{
        display: flex;
        flex-direction: column;
        height: 100%;
        >p{
          flex: 1;
          font-size: 12px;
          padding-right: 12px;
          margin-bottom: 6px;
        }
      }
    }
    .two{
      p{
        padding: 10px 0;
        text-align: center;
        i{
          font-size: 40px;
          color: $blue;
          cursor: pointer;
          &:hover{
            color: lighten($blue, 10%)
          }
        }
      }
      >div{
        text-align: center;
      }
    }
    .three{
      display: flex;
      flex-direction: column;
      >div{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        >p{
          width: 160px;
          padding: 6px 10px 6px 0;
          display: flex;
          align-items: center;
          cursor: pointer;
          @extend .transition;
          &:hover{
            color: $blue;
            @extend .transition;
          }
          i{
            font-size: 20px;
            height: 20px;
            margin-right: 3px;
          }
        }
      }
    }
  }
  // 余额
  .balance{
    display: flex;
    margin-top: 12px;
    position: relative;
    .show_more{
      position: absolute;
      top: 0;
      left: 100%;
      background: #748397;
      color: #fff;
      height: 158px;
      width: 32px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      cursor: pointer;
    }
    .child{
      display: flex;
      flex-direction: column;
      >p{
        flex: 1;
        display: flex;
        align-items: flex-end;
        padding-bottom: 12px;
        font-size: 26px;
        sup{
          font-size: 13px;
          margin-left: 6px;
        }
      }
      >div{
        display: flex;
        align-items: center;
        span{
          margin-left: 16px;
          @extend .transition;
          &:hover{
            color: $blue;
            cursor: pointer;
            @extend .transition;
          }
        }
      }
    }
  }

  // 历史记录
  .history{
    margin-top: 12px;
    border-bottom: 0;
    >h5{
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 14px 0 20px;
      >p{
        font-size: 18px;
      }
      span{
        font-weight: 500;
        margin-left: 16px;
        color: $blue;
        &:hover{
          color: lighten($blue, 10%);
          cursor: pointer;
        }
      }
    }
  }
}

.formItems{
  border: $border;
  margin-bottom: 20px;
}

</style>
